import { env } from '@/utils/env'

// For testing purposes, we want to run the interval every 2 seconds.
// Otherwise, we would run the checker every minute.
export const TIMEOUT_CHECKER_INTERVAL = env('IBC_TIMEOUT_TESTING') === 'true' ? 2 * 1000 : 60 * 1000

// By default, we want to trigger the "return later" state if the IBC takes more than a minute.
export const IBC_RETURN_LATER_MS = Number(env('IBC_RETURN_LATER_MS', String(60_000)))
